import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatRow, MatTableDataSource } from '@angular/material/table';
import { GetStreamRecurringLoadsResponse, RecurringLoadData, StreamSamplingFreq } from '../../../../interfaces/streamrecurringLoad';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { FeedstockService } from '../../../../services/feedstockservice';
import { ConfirmationDialogComponent, ConfirmationDialogData } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { AddeditRecurringloadsComponent } from '../addedit-recurringloads/addedit-recurringloads.component';
import { AddeditSamplefreqComponent } from '../addedit-samplefreq/addedit-samplefreq.component';
import { RolePermissionsService } from '../../../../services/role-permissions.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LoadScheduleControlFlags, ScreenName } from '../../../../interfaces/securityPermissions';
import { RoleService } from '../../../../services/role.service';

@Component({
  selector: 'app-sampling-frequencies',
  imports: [
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    CommonModule,
    FormsModule,
    MatIcon,
    MatRow,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatDialogModule,
    DragDropModule
],
  templateUrl: './sampling-frequencies.component.html',
  styleUrl: './sampling-frequencies.component.scss'
})
export class SamplingFrequenciesComponent implements OnInit {
  permissions = inject(RolePermissionsService);
  private dialogRef = inject(MatDialogRef<SamplingFrequenciesComponent>);
  public data: RecurringLoadData = inject(MAT_DIALOG_DATA);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  streamId: number = 0;
  genid = 0
  canAdd: boolean = true; 
  canEditDelete: boolean = false; 

  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<StreamSamplingFreq>([]);
  sampleFreqData: StreamSamplingFreq[] = [];
  controlPermissions: LoadScheduleControlFlags = new LoadScheduleControlFlags();

  constructor(private fsService: FeedstockService,private _dialog: MatDialog, private rolesService: RoleService){
  }  

  ngOnInit(): void {
    this.streamId = this.data.streamid;
    this.genid = this.data.genid;
    console.log('sampling freq Loads opened for Stream ID:', this.streamId);
    
    this.displayedColumns = [
      'actions',
      'typeName', 
      'freqTypeName', 
      'testingTypeName',
      'sampleUpOnFirstDelivery'
    ];
        
    let roles = this.rolesService.getRolesAsString();
    this.permissions.getRolePermissionsNew(roles, ScreenName.SF, 0).subscribe({
      next: (perms: LoadScheduleControlFlags) => {
        this.controlPermissions = perms;
      }
    })
    this.loadSamplingFreqData(this.streamId);
  }
  
  loadSamplingFreqData(id: number): void {    
    this.fsService.getStreamSamplingFrequencies(this.streamId, this.genid).subscribe({
      next: (res: StreamSamplingFreq[]) => {
        console.log("sample freq res", res);
        this.sampleFreqData = res;
        this.dataSource = new MatTableDataSource(this.sampleFreqData);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      }
    });
  }
  
  close(): void {
    this.dialogRef.close(false);
  }
    
  openAddEditForm(row: StreamSamplingFreq | null, task: string): void {
    const dialogRef = this._dialog.open(AddeditSamplefreqComponent, {
      data: {
        editData: row,
        streamId: this.streamId,
        genId: this.genid,
        canSave: this.controlPermissions.addButton || this.controlPermissions.edit
      },
      width: '650px',
      disableClose: true,
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadSamplingFreqData(this.streamId);
      }
    });
  }

  onDeleteSamplingFreq(id: number, name: string): void {
    const dialogData: ConfirmationDialogData = {
      title: 'Confirm Deletion',
      message: `Are you sure you want to delete Sampling Frequency: ${name}?`,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'warn'
    };

    this._dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      panelClass: 'delete-confirmation-dialog',
      data: dialogData,
      disableClose: true
    }).afterClosed().subscribe(result => {
      if (result) {
        if (id !== null && id !== undefined) {          
          this.fsService.deleteSampleFreq(id).subscribe({
            next: () => {
              this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
            }
          });
        }
      }
    });
  }
}
